<script lang="ts">
    import ReviewStar from "./ReviewStar.svelte";

    export let review: number;
    export let reviews_count: number;
    export let id: string;

</script>

<div title={`${review} out of 100`} class="fs-recommendation-product-review-container">
    {#each {length: 5} as _, i}
                <ReviewStar percentage={Math.min(1, ((review / 100) - (0.2 * i)) / 0.2) * 100}
                            id={`${id}-${i + 1}`}
                            />
            {/each}
    <small class="reviews-count avg fs-recommendation-review-avg">{(review * 0.05).toFixed(1)}</small>
    {#if reviews_count}
        <small class="reviews-count fs-recommendation-review-count">({reviews_count})</small>
    {/if}

</div>

<!--suppress CssUnresolvedCustomProperty -->
<style>

    .reviews-count {
        color: grey;
    }

    .avg {
        display: none;
    }

</style>